/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Confirm_Check_NextInputs */

const en_confirm_check_next = /** @type {(inputs: Confirm_Check_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check next lesson (${i?.count} left)`)
};

const he_confirm_check_next = /** @type {(inputs: Confirm_Check_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`בדוק את השיעור הבא (נותרו ${i?.count})`)
};

/**
* | output |
* | --- |
* | "Check next lesson ({count} left)" |
*
* @param {Confirm_Check_NextInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_check_next = /** @type {((inputs: Confirm_Check_NextInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Check_NextInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_check_next(inputs)
	return he_confirm_check_next(inputs)
});